import * as React from 'react'

import { cn } from './cn'

export interface BreadcrumbsProps extends React.HTMLAttributes<HTMLElement> {
  separator?: React.ReactNode
}

const Breadcrumbs = React.forwardRef<HTMLElement, BreadcrumbsProps>(
  ({ separator = '/', className, children, ...props }, ref) => {
    const items = React.Children.toArray(children).filter(Boolean)
    return (
      <nav ref={ref} aria-label="breadcrumb" className={className} {...props}>
        <ol className="m-0 flex list-none flex-wrap items-center gap-2 p-0 text-sm text-text-secondary">
          {items.map((child, i) => (
            <React.Fragment key={i}>
              {i > 0 && (
                <li aria-hidden className="select-none text-text-disabled">
                  {separator}
                </li>
              )}
              <li className="flex items-center">{child}</li>
            </React.Fragment>
          ))}
        </ol>
      </nav>
    )
  },
)
Breadcrumbs.displayName = 'Breadcrumbs'

export default Breadcrumbs
